<div #trigger class="relative">
  <!-- Label au-dessus -->
  <corp-control-title [corp-title]="corpLabel" [corp-size]="corpSize" ></corp-control-title>

  <!-- Conteneur principal -->
  <div>
    <!-- Bouton affichant la sélection -->
      <button
        type="button"
        [disabled]="corpLoading"
        (click)="toggle($event)"
        class="flex items-center justify-between"
        [ngClass]="[
            !(selected && 'dialCode' in selected) ? 'corp-control corp-control-' + corpSize : '',
            (ngControl?.invalid && (ngControl?.touched || ngControl?.dirty)) ? 'border-red-500' : '',
            disabled  ? 'opacity-50 !cursor-not-allowed' : '',
            corpReadonly ? '!cursor-not-allowed' : ''
        ]">

          @if(selected && 'imgPath' in selected) {
            <img class="h-10 w-10 m-1" [src]="selected.imgPath" alt="" />
          }

          <!-- mode phone: affichage du pays seulement -->
          @if(selected && 'dialCode' in selected)
          {

          }
          @else {
            @if(selected && 'value' in selected) {
              <span [class]="selected.value" class="h-5 w-5 flex items-center justify-center"></span>
            }
            
            <!-- selected.label ou corpValue.label (enfonction de utilisation de traduction ou pas ) -->
            @if(corpValue == null){
              <span class="flex-1 ml-2">{{ selected?.label }} {{(corpValue && typeof corpValue === 'object' && 'dialCode' in corpValue)}}</span>
            }
            
            @if(corpValue && typeof corpValue === 'object' && 'label' in  corpValue) {
              {{ corpValue.label }}
            }
            
            @if(selected?.code) {
              <span class="ml-2 px-2 py-0.5 text-xs font-medium bg-primary-500 rounded-full text-white">
                {{ selected?.code }}
              </span>
            }
          }

          

        <!-- Spinner ou flèche -->
        <div class="flex items-center gap-2 ml-2">
          @if (corpLoading) {
            <div class="animate-spin h-4 w-4 border-[2px] border-gray-300 border-t-primary-500 rounded-full"></div>
          } @else {
            <!-- <svg class="h-4 w-4 text-gray-400 transition-transform" [ngClass]="{ 'rotate-180': isOpen }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg> -->
            <span
              class="material-symbols-outlined text-gray-400 transition-transform"
              [ngClass]="{ 'rotate-180': isOpen }">
              expand_more
            </span>
          }
        </div>
    </button>
  </div>
</div>

<!-- Template déporté ! -->
<ng-template #overlayTpl let-options="options">
  <div class="bg-white border border-gray-200 rounded-lg shadow-lg overflow-visible"
    (click)="$event.stopPropagation()">
    <!-- Barre de recherche -->
    <div class="p-2 border-b border-gray-200">
      <input
        #searchInput
        type="text"
        [formControl]="searchControl"
        (click)="$event.stopPropagation()"
        placeholder="Rechercher..."
        class="w-full px-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400"
      />
    </div>

    <!-- Liste -->
    <div class="dropdown-list">
      @for(opt of filteredOptions; track opt.id) {
        <div
            class="group relative  dropdown-item px-3 py-2 text-gray-400 hover:bg-gray-100 cursor-pointer flex items-center w-full dark:bg-[#0c1427] dark:hover:bg-primary-400 dark:text-gray-100"
            [ngClass]="{
              'text-white cursor-not-allowed bg-gray-200': !opt.availability.isAvailable
            }"

            (click)="select(opt)"
            
            (mouseenter)="hoveredOption = opt.id"
            (mouseleave)="hoveredOption = null"
            >
            
            @if(!opt.availability.isAvailable && hoveredOption === opt.id) {
              <div
                class="absolute inset-0
                      bg-primary-500/60
                      flex flex-col items-center justify-center
                      gap-1
                      z-[9999]
                      cursor-not-allowed">

                <!-- <span class="material-symbols-outlined text-white">
                  lock
                </span> -->

                <span class="text-white text-xs text-center px-2">
                  {{ opt.availability.label }}
                </span>

              </div>
            }

            @if(opt.imgPath){
              <img 
                class="h-10 w-10 " 
                [ngClass]="{'grayscale': !opt.availability.isAvailable }"
                [src]="opt.imgPath" alt="" />
            }

            @if(opt.value){
              <span [class]="opt.value" class="h-5 w-5 flex items-center justify-center"></span>
            }
            @if(opt.label){
              <span class="flex-1 ml-2">{{ opt.label }}</span>
            }
            @if(!opt.availability.isAvailable){
              <span
                class="material-symbols-outlined text-primary-500 text-lg"
              >
                lock
              </span>
            }

            @if(opt.dialCode){
              <span class="ml-2 px-2 py-0.5 text-xs font-medium bg-primary-500 rounded-full text-white flex items-center justify-center">( + {{ opt.dialCode }} )</span>
            }
            
            @else {
              @if(opt.code){
                <span 
                  class="ml-2 px-2 py-0.5 text-xs font-medium bg-primary-500 rounded-full text-white"
                  [ngClass]="{'grayscale': !opt.availability.isAvailable }"
                  >{{ opt.code }}
                </span>
              }
            }
           
        </div>
      }
    </div>

  </div>
</ng-template>

